<template lang="pug">
	section#prouni
		div.wrapper
			h2
				| Transferência por meio de bolsa PROUNI
				br
				span Você conquistou sua bolsa PROUNI e deseja estudar na UniFAEL? Então confira os passos abaixo para realizar a sua transferência.

			p.condicao Condição para inscrição:
			p.regra Ser aluno de curso superior devidamente autorizado ou reconhecido pelo MEC e que haja oferta de bolsa PROUNI.

			p.condicao Disponibilidade de bolsa por polo:
			p.regra Para realizar a Transferência de bolsa PROUNI o candidato deve certificar-se que possui oferta de bolsa ao polo e curso desejado.

			p.condicao Confira abaixo os cursos com oferta de bolsa PROUNI:
			p.regra
				| Administração - EAD
				br
				| Ciências Contábeis - EAD
				br
				| Geografia - EAD
				br
				| Gestão Ambiental - EAD
				br
				| Gestão Pública - EAD
				br
				| História - EAD
				br
				| Letras - Português e Espanhol - EAD
				br
				| Letras - Português e Inglês - EAD
				br
				| Matemática - EAD
				br
				| Pedagogia - EAD
				br
				| Recursos Humanos – EAD

			div.box
				h3 Polos com disponibilidade de bolsa PROUNI 2° semestre 2021
				p Para verificar se o polo em que deseja realizar a transferência de bolsa possui disponibilidade:
				a(href="https://media.fael.edu.br/prouni/polos-prouni", target="_blank") Clique aqui

			p.condicao Forma de ingresso:
			p.regra
				| Parecer coordenação PROUNI;
				br
				br
				| Após certificar-se de que seu polo escolhido e curso possuem a disponibilidade de oferta de bolsa,
				| deve ser encaminhado a coordenação PROUNI pelo e-mail Prouni@fael.edu.br a
				| listagem dos documentos abaixo para emissão do termo de aceitação da bolsa.
				br
				br

			p.condicao Documentos:
			ul
				li
					| Histórico Escolar de Graduação com a assinatura do Secretário da IES de origem;
				li
					| Ementas das disciplinas cursadas;
				li
					| Sistema de avaliação;
				li
					| Histórico escolar do ensino médio com notas e diploma/certificado de conclusão do ensino médio;
				li
					| Termo de Transferência de Concessão de Bolsa PROUNI (chave de transferência);
				li
					| Histórico de concessão de bolsa no PROUNI (trata-se de print de tela do Sisprouni – e quem retira
					| é o Coordenador do PROUNI da outra IES de origem);
				li
					| Termo de Concessão de Bolsa na IES de origem;
				li
					| Descrição de Regimento sobre o processo de avaliação do curso de origem.
</template>

<script>
	export default {
		name: "section-prouni"
	}
</script>

<style lang="stylus" scoped src="./Prouni.styl"></style>
